import React from 'react'
import ReactDOM from 'react-dom'
import { PropTypes } from 'prop-types'
import StringHelper from '../../helpers/string_helper'
import './show_more_component.scss'
import i18n from '../../../i18n'

export default class ShowMore extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      needExpand: true,
      expanded: false
    }
    this.FIRSTVIEW_HEIGHT = 122 // 1.5rem * 1.625  * 5 = 121.875 (font-size * line-height * lines)
  }

  componentDidMount() {
    if (this.contentWrapper && this.contentWrapper.scrollHeight < this.FIRSTVIEW_HEIGHT) {
      this.setState({ needExpand: false })
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.children && prevProps.children != this.props.children) {
      if (this.state.needExpand == false && this.contentWrapper.scrollHeight >= this.FIRSTVIEW_HEIGHT) {
        this.setState({ needExpand: true })
      }
    }
  }

  onClick(e) {
    e.preventDefault()
    this.setState({ expanded: !this.state.expanded })
  }

  styleName() {
    const classes = ['see-more-wrap']
    if (this.state.expanded) {
      classes.push('expand')
    }
    if (this.state.needExpand == false) {
      classes.push('revealed')
    }
    return classes.join(' ')
  }

  formatContent() {
    if (typeof this.props.children == 'string') {
      return StringHelper.nl2br(this.props.children)
    } else {
      return this.props.children
    }
  }

  render() {
    const buttonTitle = (this.state.expanded) ? this.props.less : this.props.more
    return (
      <div className={this.props.class} styleName={this.styleName()}>
        <div className="n-text tsw-text see-more-content" styleName="see-more-content" ref={(ref) => { this.contentWrapper = ReactDOM.findDOMNode(ref) }}>
          {this.formatContent()}
        </div>
        <div className="see-more-btn" styleName="see-more-btn" onClick={this.onClick.bind(this)}>{buttonTitle}</div>
      </div>
    )
  }
}

ShowMore.propTypes = {
  class: PropTypes.string,
  more: PropTypes.string,
  less: PropTypes.string
}

ShowMore.defaultProps = {
  class: "",
  more: i18n.t('common:more'),
  less: i18n.t('common:hide')
}
